import * as React from 'react';
import './Dropdown.css';
import arrow from './arrow.svg';
import OutsideClickHandler from 'react-outside-click-handler';

interface Props {
    onChange: (value: string) => void;
    options: string[];
    class: 'toolbar-select' | 'admin-select' | 'navbar-select';
    color: 'blue' | 'green' | 'gray' | 'white';
    placeholder: string;
    selectedOption?: string;
}

interface State {
    isDropdownOpen: boolean;
}

export default class Dropdown extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isDropdownOpen: false
        };
    }

    public render(): JSX.Element {
        const classes = this.props.class + ' ' + this.props.color;
        const dropdownClasses = 'dropdown-menu ' + this.props.color;
        const buttonClasses = `dropdown-button ${this.props.options.length === 0 ? 'disabled' : ''}`;

        const dropdownLabel = this.props.selectedOption || this.props.placeholder;
        return (
            <OutsideClickHandler onOutsideClick={this.closeDropdown}>
                <div className={classes}>
                    <button className={buttonClasses} onClick={this.onDropdownButtonClicked}>
                        {dropdownLabel}
                        <img className="dropdown-arrow" src={arrow} />
                    </button>
                    {this.state.isDropdownOpen && this.props.options.length > 0 && (
                        <div className={dropdownClasses}>
                            {this.props.options.map(option => (
                                <a href="#" key={option} onClick={this.onFilterSelected}>
                                    {option}
                                </a>
                            ))}
                        </div>
                    )}
                </div>
            </OutsideClickHandler>
        );
    }

    private onDropdownButtonClicked = (): void => {
        this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
    };

    private onFilterSelected = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        if (e.currentTarget.textContent) {
            this.props.onChange(e.currentTarget.textContent);
        }
        this.onDropdownButtonClicked();
    };

    private closeDropdown = (): void => {
        this.setState({ isDropdownOpen: false });
    };
}



// WEBPACK FOOTER //
// ./src/view/common/Dropdown.tsx